import { UPLOADS_URL } from "../../config/constants";

function childInitials(firstName = "", lastName = "") {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || "C";
}

function childName(child) {
  return `${child?.firstName || ""} ${child?.lastName || ""}`.trim() || "Child";
}

export default function StackedAvatars({
  items = [],
  max = 4,
  emptyLabel = "None",
  onItemClick,
}) {
  const children = items.filter(
    (child) => child && (child.firstName || child.lastName || child.rollNumber || child.image)
  );

  if (!children.length) {
    return <span className="data-avatar-stack-empty">{emptyLabel}</span>;
  }

  const visible = children.slice(0, max);
  const overflow = children.length - visible.length;

  return (
    <div className="data-avatar-stack" aria-label={`${children.length} children`}>
      {visible.map((child, index) => {
        const name = childName(child);
        const toneClass = `is-tone-${index % 5}`;
        const content = child.image ? (
          <img className="data-avatar-stack-img" src={`${UPLOADS_URL}/${child.image}`} alt={name} />
        ) : (
          <span>{childInitials(child.firstName, child.lastName)}</span>
        );

        return (
          <button
            key={child._id || `${name}-${index}`}
            type="button"
            className={`data-avatar-stack-item ${toneClass}`}
            style={{ zIndex: index + 1 }}
            title={name}
            aria-label={name}
            onClick={() => onItemClick?.(child)}
          >
            {content}
          </button>
        );
      })}
      {overflow > 0 ? (
        <span className="data-avatar-stack-more" style={{ zIndex: visible.length + 1 }}>
          +{overflow}
        </span>
      ) : null}
    </div>
  );
}
